import { clsx } from "../functions";
import {ReactNode, useContext } from "react";
import "./plus.css";
import { useStore } from "../state/state.ts";
import { MENU_ITEMS, type MenuItem } from "../state/types.ts";
import { inputOnKeyUp } from "../functions.ts";
import { ConfigContext } from "../config_context.ts";

export default function PlusMenu(props: {label: string, additional_items?: Array<MenuItem>, dialogs: Record<string, ReactNode>}) {
  const set_selected_menu_item = useStore(
    (state) => state.set_selected_menu_item,
  );
  const selected_menu_item = useStore((state) => state.selected_menu_item);
  const keep_menu_open = useStore((state) => state.keep_menu_open);
  const close_menu = useStore((state) => state.close_menu);
  const open_menu = useStore((state) => state.open_menu);
  const menu_items_sorting = useContext(ConfigContext).menu_items_sorting;
  const plus_expanded = useContext(ConfigContext).plus_expanded;

  
  let items = [...MENU_ITEMS, ...(props.additional_items !== undefined ? props.additional_items : [] )];
  if(menu_items_sorting){
    const sorted_items = menu_items_sorting.map((item_id) => MENU_ITEMS.find((i)=>i.id == item_id));
    items = sorted_items;
  }
  const push_modal = useStore((state) => state.push_modal_closeable);

  const is_open = selected_menu_item || keep_menu_open || plus_expanded;

  return (
    <>
      <div
        className={clsx("plus__menu", is_open && "plus__menu--open")}
      >
        {!plus_expanded && <Plus
          label={props.label}
          onClick={() => {
            if (selected_menu_item) {
              close_menu();
            } else {
              open_menu();
              set_selected_menu_item(items[0].id);
            }
          }}
        />}
        <ul className="plus__menu-list"
          inert={!is_open}
          role="menu"
          aria-label="Details Hinzufügen"
          >
          
          {items.map((item) => (
            <PlusMenuItem
              id={item.id}
              key={item.label}
              label={item.label}
              hovered={selected_menu_item == item.id}
              onPointerEnter={() => {
                set_selected_menu_item(item.id);
              }}
              onClick={() => {
                push_modal(props.dialogs[item.id]);
                setTimeout(() => {
                  document.querySelector(".modal [tabindex]").focus();
                }, 100); 
              }}
            />
          ))}
        </ul>
      </div>
    </>
  );
}

function PlusMenuItem(props: {
  id: string;
  label: string;
  hovered: boolean;
  onPointerEnter: () => void;
  onClick: () => void;
}) {
  return (
    <li
      role="menuitem"
      tabIndex={0}
      className={clsx(
        "plus__menu-item ",
        props.hovered && "plus__menu-item--hovered",
      )}
      style={{
        backgroundColor: props.hovered
          //? "var(--" + props.id + ")"
           ? "var(--active)"
          : "transparent",
      }}
      onPointerEnter={props.onPointerEnter}
      onClick={props.onClick}
      onKeyUp={(event)=>inputOnKeyUp(event, ()=>{props.onClick()})}
    >
      {props.label}
    </li>
  );
}

function Plus(props: {label:string, onClick: () => void }) {
  return (
      <div 
          tabIndex={0}
          className="plus" 
          role="button"
          aria-label={props.label}
          onClick={props.onClick}
          onKeyUp={(event)=>inputOnKeyUp(event, ()=>{props.onClick()})}>
        <span aria-hidden className="plus-label" >{props.label}</span>
        <div aria-hidden className="plus-bars">
          <div className="plus-bar"></div>
          <div className="plus-bar"></div>
        </div>
      </div>
  );
}
